export type TriageStatus = "accepted" | "declined" | "duplicate";

export type DeclineReason =
	| "not_relevant"
	| "already_addressed"
	| "scope_issue"
	| "other";

export const DECLINE_REASON_LABELS: Record<DeclineReason, string> = {
	not_relevant: "Not relevant to evaluation",
	already_addressed: "Already addressed in submission",
	scope_issue: "Scope issue — outside evaluation criteria",
	other: "Other",
};

export const TRIAGE_STATUS_LABELS: Record<TriageStatus, string> = {
	accepted: "Accepted",
	declined: "Declined",
	duplicate: "Duplicate",
};


export interface ReviewClarificationCreatedBy {
	id: number;
	name: string;
	email: string;
	company_name?: string;
}

export interface ReviewClarification {
	id: number;
	reference_number: number;
	clarification_text: string;
	original_clarification_text: string | null;
	relates_to: string | null;
	rfx_invite_id: number;
	supplier_name: string;
	clarification_type_id: number;
	clarification_type_name?: string;
	clarification_impact_id?: number;
	impact_label?: string;
	triage_status: TriageStatus | null;
	decline_reason: string | null;
	decline_reason_category: DeclineReason | null;
	is_approved: boolean | null;
	duplicate_of_id: number | null;
	source_clarification_id: number | null;
	reviewed_by_user: number | null;
	reviewed_by_name: string | null;
	reviewed_at: string | null;
	edited_by_user: number | null;
	edited_by_name: string | null;
	edited_at: string | null;
	created_by: ReviewClarificationCreatedBy | null;
	created_at: string;
	updated_at: string;
}

export interface TriageClarificationPayload {
	triage_status: TriageStatus;
	decline_reason?: string;
	decline_reason_category?: DeclineReason;
}

export interface BatchTriagePayload {
	clarification_ids: number[];
	triage_status: "accepted" | "declined";
	decline_reason?: string;
	decline_reason_category?: DeclineReason;
}

export interface DuplicateClarificationPayload {
	main_clarification_id: number;
	duplicate_ids: number[];
}

export interface ApplyToAllPayload {
	clarification_id: number;
}

export interface EditClarificationTextPayload {
	clarification_text: string;
}

export interface StepCompletePayload {
	date_due?: string;
}

export interface ClarificationReviewSummary {
	total: number;
	reviewed: number;
	accepted: number;
	declined: number;
	duplicate: number;
	pending: number;
}

// --- AI Review types ---

export type AISuggestionStatus = "pending" | "accepted" | "dismissed";

export interface AITriageSuggestion {
	clarification_id: number;
	suggested_status: TriageStatus;
	reasoning: string;
	confidence: number;
	text_corrections?: string | null;
}

export interface AIDuplicateGroup {
	suggested_main_id: number;
	duplicate_ids: number[];
	reasoning: string;
	confidence: number;
}

export interface AIReviewSummary {
	focus_areas: string[];
	supplier_counts: Record<string, number>;
	themes: string[];
	patterns: string[];
}

export interface AIReviewResponse {
	summary: AIReviewSummary;
	suggestions: AITriageSuggestion[];
	duplicates: AIDuplicateGroup[];
}
